import React from 'react';
import { Link } from 'react-router-dom';

/** A single row of the mobile slide-down menu. */
export const MobileNavLink = ({ to, isActive, onClick, children, primary = false }) => {
  if (primary) {
    return (
      <Link
        to={to}
        onClick={onClick}
        className="px-4 py-3 bg-church-green text-white rounded-lg font-medium text-center mt-2"
      >
        {children}
      </Link>
    );
  }
  return (
    <Link
      to={to}
      onClick={onClick}
      className={`px-4 py-3 rounded-lg font-medium ${
        isActive ? 'bg-green-50 text-church-green' : 'hover:bg-green-50'
      }`}
    >
      {children}
    </Link>
  );
};
